import { AppProps } from 'next/app';
import { ToastProvider } from 'react-toast-notifications';
import { rootStore, Provider } from '@models/Root';
import { ApolloProvider } from '@apollo/client';
import 'cropperjs/dist/cropper.css';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { Layout, ConfigProvider, Result } from 'antd';
import NProgress from 'nprogress';
import '../modules/timetable/css/manageTimeTable.css';
import 'nprogress/nprogress.css';
import 'react-image-lightbox/style.css';
import '../styles/globals.css';
import 'simplebar/dist/simplebar.min.css';
import { apolloClient } from '@lib/apollo';
import en_GB from 'antd/lib/locale-provider/en_GB';
import moment from 'moment';
import 'moment/locale/en-gb';
import Head from 'next/head';
import { AppLayout } from '@components/app';

moment.locale('en-gb');

const IMSApp = ({ Component, pageProps }: AppProps) => {
  const router = useRouter();

  useEffect(() => {
    router.events.on('routeChangeStart', NProgress.start);
    router.events.on('routeChangeComplete', NProgress.done);
    router.events.on('routeChangeError', NProgress.done);

    return () => {
      router.events.off('routeChangeStart', NProgress.start);
      router.events.off('routeChangeComplete', NProgress.done);
      router.events.off('routeChangeError', NProgress.done);
    };
  }, []);

  return (
    <>
      <Head>
        <title>Institute Management System | William Angliss Institute @ SLIIT</title>
      </Head>

      <ToastProvider>
        {/* @ts-ignore */}
        <Provider value={rootStore}>
          <ApolloProvider client={apolloClient}>
            <ConfigProvider locale={en_GB}>
              {/* <div className="main-content"> */}
              <Layout className="main-content" style={{ minHeight: '100vh' }}>
                <AppLayout>
                  {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                  <Component {...pageProps} />
                </AppLayout>
              </Layout>
              {/* </div> */}

              <div className="mobile-content">
                <Result
                  status="500"
                  title="Mobile devices not supported!"
                  subTitle="Sorry, currently we do not support mobile devices at the moment! Please try on a desktop device."
                />
              </div>
            </ConfigProvider>
          </ApolloProvider>
        </Provider>
      </ToastProvider>
    </>
  );
};

export default IMSApp;
